import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import nprogress from 'nprogress';
import 'nprogress/nprogress.css';

// Configure nprogress
nprogress.configure({ 
  showSpinner: false, 
  speed: 400, 
  minimum: 0.1 
});

export const usePageLoading = () => {
  const location = useLocation();

  useEffect(() => {
    nprogress.start();
    
    const timer = setTimeout(() => {
      nprogress.done();
    }, 200);

    return () => {
      clearTimeout(timer);
      nprogress.done();
    };
  }, [location.pathname]);
};
